import { Component } from '@angular/core';
import { MatDivider } from '@angular/material/list';

@Component({
    selector: 'app-subtitulo-seccion-complemento',
    templateUrl: './subtitulo-seccion-complemento.component.html',
    styleUrls: ['./subtitulo-seccion-complemento.component.scss'],
    imports: [MatDivider]
})
export class SubtituloSeccionComplementoComponent { }
